import React from 'react';

const MenuManagementContext = React.createContext();

export default MenuManagementContext;
